"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcTooltipBehavior = void 0;
var default_behavior_1 = require("../../../common/models/default-behavior");
var helpers_1 = require("../../../common/helpers");
var common_constants_1 = require("../../../common/constants/common-constants");
var tooltip_constants_1 = require("./tooltip-constants");
var tooltip_constants_2 = require("./tooltip-constants");
var tooltip_constants_3 = require("./tooltip-constants");
var tooltip_constants_4 = require("./tooltip-constants");
var tooltip_constants_5 = require("./tooltip-constants");
var tooltip_constants_6 = require("./tooltip-constants");
var tooltip_constants_7 = require("./tooltip-constants");
var tooltip_constants_8 = require("./tooltip-constants");
var tooltip_constants_9 = require("./tooltip-constants");
var tooltip_constants_10 = require("./tooltip-constants");
var tooltip_constants_11 = require("./tooltip-constants");
var tooltip_constants_12 = require("./tooltip-constants");
var tooltip_constants_13 = require("./tooltip-constants");
var tooltip_constants_14 = require("./tooltip-constants");
var tooltip_constants_15 = require("./tooltip-constants");
var BcTooltipBehavior = (function (_super) {
    __extends(BcTooltipBehavior, _super);
    function BcTooltipBehavior() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.margin = tooltip_constants_10.BC_TOOLTIP_EIGHT;
        return _this;
    }
    BcTooltipBehavior.setUpAll = function () {
        var tooltipElements = Array.from(document.querySelectorAll(".".concat(tooltip_constants_12.BC_TOOLTIP_SELECTOR)));
        var elements = [];
        for (var _i = 0, tooltipElements_1 = tooltipElements; _i < tooltipElements_1.length; _i++) {
            var element = tooltipElements_1[_i];
            var bcTooltipBehavior = new BcTooltipBehavior();
            bcTooltipBehavior.setElement(element);
            bcTooltipBehavior.setUp();
            elements.push(bcTooltipBehavior);
        }
        return elements;
    };
    BcTooltipBehavior.prototype._setUp = function () {
        this.buildView();
        this.addListeners();
    };
    BcTooltipBehavior.prototype.buildView = function () {
        var innerText = this.mySelf.getAttribute(tooltip_constants_13.BC_TOOLTIP_TEXT_ATTRIBUTE);
        var innerTitle = this.mySelf.getAttribute(tooltip_constants_1.BC_TOOLTIP_TITLE_ATTRIBUTE);
        var buttonText = this.mySelf.getAttribute(tooltip_constants_7.BC_TOOLTIP_BUTTON_TEXT_ATTRIBUTE);
        this.parentELementClass = this.mySelf.getAttribute(tooltip_constants_15.BC_TOOLTIP_PARENT_ELEMENT_CLASS);
        this.position = this.mySelf.getAttribute(tooltip_constants_11.BC_TOOLTIP_POSITION_ATTRIBUTE);
        this.classNameWithId = "".concat(tooltip_constants_8.BC_TOOLTIP_CONTAINER_SELECTOR, "--").concat(BcTooltipBehavior.ID);
        BcTooltipBehavior.ID++;
        this.mySelf.setAttribute('tabindex', '0');
        this.tooltipElement = this.createElement('div', 'class', "".concat(tooltip_constants_8.BC_TOOLTIP_CONTAINER_SELECTOR, " ").concat(this.classNameWithId));
        this.arrowElement = this.createElement('div', 'class', tooltip_constants_1.BC_TOOLTIP_ARROW_CLASS);
        var text = this.createElementWithText('p', innerText ? innerText : '');
        (0, helpers_1.addFocusable)(text);
        this.position = this.position ? this.position.toLowerCase() : 'top';
        this.arrowElement.classList.add(this.arrowElement.classList.item(0) + '--' + this.position);
        this.setElementTitle(innerTitle);
        this.tooltipElement.appendChild(text);
        this.tooltipElement.appendChild(this.arrowElement);
        this.setElementButton(buttonText);
        document.body.appendChild(this.tooltipElement);
        if ((0, helpers_1.isMobileDevice)()) {
            this.tooltipElement.classList.add(tooltip_constants_4.BC_TOOLTIP_BUTTON_CLOSE_CLASS);
        }
    };
    BcTooltipBehavior.prototype.setElementButton = function (buttonText) {
        var _this = this;
        if (buttonText != null && buttonText !== 'undefined') {
            var button = this.createElementWithText('button', buttonText ? buttonText : '');
            button.classList.add(tooltip_constants_3.BC_TOOLTIP_BUTTON_CLASS_TYPE);
            button.classList.add("".concat(tooltip_constants_12.BC_TOOLTIP_SELECTOR, "-button"));
            button.setAttribute(tooltip_constants_2.BC_TOOLTIP_BUTTON_CLASS, '');
            button.setAttribute('typeButton', 'secondary');
            button.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function () {
                _this.hideTooltip();
                _this.buttonClickCallback();
            });
            (0, helpers_1.addFocusable)(button);
            this.tooltipElement.appendChild(button);
        }
    };
    BcTooltipBehavior.prototype.setElementTitle = function (innerTitle) {
        if (innerTitle != null && innerTitle !== 'undefined') {
            var title = this.createElementWithText('h5', innerTitle ? innerTitle : '');
            this.tooltipElement.appendChild(title);
            this.tooltipElement.appendChild(this.createElement('hr', 'class', tooltip_constants_9.BC_TOOLTIP_DIVIDER_CLASS));
            (0, helpers_1.addFocusable)(title);
        }
    };
    BcTooltipBehavior.prototype.showTooltip = function () {
        this.fadeIn(this.mySelf, null, this.tooltipElement, false);
    };
    BcTooltipBehavior.prototype.hideTooltip = function () {
        this.fadeOut(this.mySelf, null, this.tooltipElement, false);
    };
    BcTooltipBehavior.prototype.addListeners = function () {
        var _this = this;
        this.fadeIn(this.mySelf, common_constants_1.BcCommonConstants.EVENT_MOUSEENTER, this.tooltipElement, false);
        this.fadeIn(this.mySelf, common_constants_1.BcCommonConstants.EVENT_FOCUS, this.tooltipElement, false);
        this.fadeOut(this.mySelf, common_constants_1.BcCommonConstants.EVENT_MOUSEOUT, this.tooltipElement, false);
        this.fadeOut(this.mySelf, common_constants_1.BcCommonConstants.EVENT_BLUR, this.tooltipElement, false);
        window.addEventListener('resize', function () {
            _this.setPosition();
        });
        document.addEventListener('scroll', function () {
            _this.setPosition();
        });
        if (this.parentELementClass != null && this.parentELementClass !== 'undefined') {
            var parentElement = document.querySelector("div[class~='".concat(this.parentELementClass, "']"));
            parentElement
                .addEventListener('scroll', function () {
                _this.setPosition();
            });
            parentElement
                .addEventListener('resize', function () {
                _this.setPosition();
            });
        }
    };
    BcTooltipBehavior.prototype.buttonClick = function (callback) {
        this.buttonClickCallback = callback;
    };
    BcTooltipBehavior.prototype.setPosition = function () {
        var self = this.mySelf;
        switch (this.position) {
            case tooltip_constants_1.BC_TOOLTIP_BUTTON_BOTTOM: {
                this.bottomTooltip(self, this.arrowElement, this.tooltipElement);
                break;
            }
            case tooltip_constants_6.BC_TOOLTIP_BUTTON_RIGHT: {
                this.rightTooltip(self, this.arrowElement, this.tooltipElement);
                break;
            }
            case tooltip_constants_5.BC_TOOLTIP_BUTTON_LEFT: {
                this.leftTooltip(self, this.arrowElement, this.tooltipElement);
                break;
            }
            default: {
                this.topTooltip(self, this.arrowElement, this.tooltipElement);
                break;
            }
        }
    };
    BcTooltipBehavior.prototype.createElement = function (tag, tagAttribute, tagAttributeValue) {
        var el = document.createElement(tag);
        el.setAttribute(tagAttribute, tagAttributeValue);
        return el;
    };
    BcTooltipBehavior.prototype.createElementWithText = function (tag, text) {
        var el = document.createElement(tag);
        el.innerText = text;
        return el;
    };
    BcTooltipBehavior.prototype.topTooltip = function (target, arrow, tooltip) {
        this.changeArrowClass(arrow, tooltip, 'top');
        var posX = this.fixPosXIfElementIsOutScreen(target, tooltip, arrow);
        this.setElementPosition(tooltip, this.offset(target).top -
            tooltip.offsetHeight -
            arrow.offsetHeight -
            this.margin, posX.tooltip);
        this.setElementPosition(arrow, tooltip.offsetHeight, posX.arrow);
    };
    BcTooltipBehavior.prototype.offset = function (el) {
        var rect = el.getBoundingClientRect(), scrollLeft = window.pageXOffset || document.documentElement.scrollLeft, scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        return { top: rect.top + scrollTop, left: rect.left + scrollLeft };
    };
    BcTooltipBehavior.prototype.bottomTooltip = function (target, arrow, tooltip) {
        var posX = this.fixPosXIfElementIsOutScreen(target, tooltip, arrow);
        this.setElementPosition(tooltip, this.offset(target).top +
            target.offsetHeight +
            arrow.offsetHeight +
            this.margin, posX.tooltip);
        this.setElementPosition(arrow, -arrow.offsetHeight, posX.arrow);
    };
    BcTooltipBehavior.prototype.rightTooltip = function (target, arrow, tooltip) {
        var posXTooltip = this.offset(target).left +
            target.offsetWidth +
            arrow.offsetWidth +
            this.margin;
        var posY = this.centerToTarget(target, tooltip, arrow, true);
        if (posXTooltip + tooltip.offsetWidth >= document.body.offsetWidth) {
            this.topTooltip(target, arrow, tooltip);
        }
        else {
            this.changeArrowClass(arrow, tooltip, 'right');
            this.setElementPosition(tooltip, posY.tooltip, posXTooltip);
            this.setElementPosition(arrow, posY.arrow, -arrow.offsetWidth);
        }
    };
    BcTooltipBehavior.prototype.leftTooltip = function (target, arrow, tooltip) {
        var posXTooltip = this.offset(target).left -
            tooltip.offsetWidth -
            arrow.offsetWidth -
            this.margin;
        var posY = this.centerToTarget(target, tooltip, arrow, true);
        if (posXTooltip <= 0) {
            this.topTooltip(target, arrow, tooltip);
        }
        else {
            this.changeArrowClass(arrow, tooltip, 'left');
            this.setElementPosition(tooltip, posY.tooltip, posXTooltip);
            this.setElementPosition(arrow, posY.arrow, tooltip.offsetWidth);
        }
    };
    BcTooltipBehavior.prototype.fadeIn = function (elementFocusable, eventName, tooltip, options) {
        var _this = this;
        if (!eventName) {
            this.setPosition();
            return 'fade-in-opacity 100ms forwards';
        }
        elementFocusable.addEventListener(eventName, function () {
            _this.setPosition();
            tooltip.style.animation = 'fade-in-opacity 100ms forwards';
        }, options);
    };
    BcTooltipBehavior.prototype.fadeOut = function (elementFocusable, eventName, tooltip, options) {
        if (!eventName) {
            return 'fade-out-opacity 100ms forwards';
        }
        elementFocusable.addEventListener(eventName, function () {
            tooltip.style.animation = 'fade-out-opacity 100ms forwards';
        }, options);
    };
    BcTooltipBehavior.prototype.setElementPosition = function (element, top, left) {
        element.style.top = top + 'px';
        element.style.left = left + 'px';
    };
    BcTooltipBehavior.prototype.centerToTarget = function (target, tooltip, arrow, isBeside) {
        var offsetEdge = isBeside
            ? this.offset(target).top
            : this.offset(target).left;
        var offsetLength = isBeside ? 'offsetHeight' : 'offsetWidth';
        var edgeTooltip = offsetEdge - tooltip[offsetLength] / tooltip_constants_14.BC_TOOLTIP_TWO + target[offsetLength] / tooltip_constants_14.BC_TOOLTIP_TWO;
        var edgeArrow = tooltip[offsetLength] / tooltip_constants_14.BC_TOOLTIP_TWO - arrow[offsetLength] / tooltip_constants_14.BC_TOOLTIP_TWO;
        return { tooltip: edgeTooltip, arrow: edgeArrow };
    };
    BcTooltipBehavior.prototype.changeArrowClass = function (arrow, tooltip, position) {
        tooltip.removeChild(arrow);
        arrow.classList.remove(arrow.classList.item(1));
        arrow.classList.add(arrow.classList.item(0) + '--' + position);
        tooltip.appendChild(arrow);
    };
    BcTooltipBehavior.prototype.fixPosXIfElementIsOutScreen = function (target, tooltip, arrow) {
        var posX = this.centerToTarget(target, tooltip, arrow, false);
        if (posX.tooltip + tooltip.offsetWidth >= document.body.offsetWidth) {
            posX.tooltip =
                this.offset(target).left + target.offsetWidth - tooltip.offsetWidth;
            posX.arrow =
                tooltip.offsetWidth - arrow.offsetWidth - target.offsetWidth / tooltip_constants_14.BC_TOOLTIP_TWO;
        }
        else if (posX.tooltip <= 0) {
            posX.tooltip = this.offset(target).left;
            posX.arrow = target.offsetWidth / tooltip_constants_14.BC_TOOLTIP_TWO;
        }
        return posX;
    };
    BcTooltipBehavior.ID = 0;
    return BcTooltipBehavior;
}(default_behavior_1.BcDefaultBehavior));
exports.BcTooltipBehavior = BcTooltipBehavior;
